import React, { createRef } from 'react';
import cn from 'classnames';
import { withRouter } from 'next/router';
import { BodyCellPure } from '@dealroadshow/uikit/core/components/Table/DataTable/Body/BodyCell';
import { SectorCell, BondNameCell, StatusCell } from '@/finsight/ui/common/components/TableCells';
import { useFiltersContext } from '@/finsight/application/FiltersContext';
import {
  getCeCell,
  getCurrentFaceCell,
  getDealerCell,
  getDueByCell,
  getIdentifierCell,
  getListIdCell,
  getOriginalFaceCell,
  getOtherRatingCell,
  getPriceTalkCell,
  getRatingCell,
  getSpeedCell,
  getSpreadCell,
  getWalCell,
} from '../../cellCallbacks';

import spacesStyles from '@dealroadshow/uikit/core/styles/helpers/spaces.scss';
import alignStyles from '@dealroadshow/uikit/core/styles/helpers/align.scss';
import styles from '@/finsight/ui/components/bonds/common/BondTables/bondsTables.scss';

const BwicRow = (props) => {
  const { row } = props;
  const rowRef = createRef<React.LegacyRef<HTMLElement> | null>();
  const { onSearch } = useFiltersContext();

  const handleMouseEnter = () => {
    const node = rowRef.current;

    if (node) {
      // @ts-ignore
      node.querySelector('.togglerCheckbox').checked = false;
    }
  };

  return (
    <tr
      // @ts-ignore
      ref={ rowRef }
      onMouseEnter={ handleMouseEnter }
      className={ styles.row }
    >
      <BodyCellPure
        name="status"
        className={ alignStyles.alignCenter }
        rowIndex={ props.rowIndex }
        rowData={ row }
        cellCallback={ StatusCell }
      />
      <BodyCellPure
        name="sector"
        className={ alignStyles.alignLeft }
        rowIndex={ props.rowIndex }
        rowData={ row }
        cellCallback={ SectorCell }
      />
      <BodyCellPure
        name="name"
        className={ alignStyles.alignLeft }
        rowIndex={ props.rowIndex }
        rowData={ row }
        cellCallback={ BondNameCell }
      />
      <BodyCellPure
        name="originalFace"
        className={ alignStyles.alignRight }
        rowIndex={ props.rowIndex }
        rowData={ row }
        cellCallback={ getOriginalFaceCell }
      />
      <BodyCellPure
        name="currentFace"
        className={ alignStyles.alignRight }
        rowIndex={ props.rowIndex }
        rowData={ row }
        cellCallback={ getCurrentFaceCell }
      />
      <BodyCellPure
        name="wal"
        className={ alignStyles.alignRight }
        rowIndex={ props.rowIndex }
        rowData={ row }
        cellCallback={ getWalCell }
      />
      <BodyCellPure
        name="ratingMoodys"
        className={ alignStyles.alignCenter }
        rowIndex={ props.rowIndex }
        rowData={ row }
        cellCallback={ getRatingCell }
      />
      <BodyCellPure
        name="ratingSAndP"
        className={ alignStyles.alignCenter }
        rowIndex={ props.rowIndex }
        rowData={ row }
        cellCallback={ getRatingCell }
      />
      <BodyCellPure
        name="ratingFitch"
        className={ alignStyles.alignCenter }
        rowIndex={ props.rowIndex }
        rowData={ row }
        cellCallback={ getRatingCell }
      />
      <BodyCellPure
        name="ratingDBRS"
        className={ alignStyles.alignCenter }
        rowIndex={ props.rowIndex }
        rowData={ row }
        cellCallback={ getRatingCell }
      />
      <BodyCellPure
        name="ratingKroll"
        className={ alignStyles.alignCenter }
        rowIndex={ props.rowIndex }
        rowData={ row }
        cellCallback={ getRatingCell }
      />
      <BodyCellPure
        name="ratingOtherOrUnspecified"
        className={ alignStyles.alignCenter }
        rowIndex={ props.rowIndex }
        rowData={ row }
        cellCallback={ getOtherRatingCell }
      />
      <BodyCellPure
        name="spread"
        className={ alignStyles.alignRight }
        rowIndex={ props.rowIndex }
        rowData={ row }
        cellCallback={ getSpreadCell }
      />
      <BodyCellPure
        name="speed"
        className={ alignStyles.alignRight }
        rowIndex={ props.rowIndex }
        rowData={ row }
        cellCallback={ getSpeedCell }
      />
      <BodyCellPure
        name="ce"
        className={ alignStyles.alignRight }
        rowIndex={ props.rowIndex }
        rowData={ row }
        cellCallback={ getCeCell }
      />
      <BodyCellPure
        name="priceTalk"
        className={ alignStyles.alignRight }
        rowIndex={ props.rowIndex }
        rowData={ row }
        cellCallback={ getPriceTalkCell }
      />
      <BodyCellPure
        name="dealer"
        className={ alignStyles.alignRight }
        rowIndex={ props.rowIndex }
        rowData={ row }
        cellCallback={ getDealerCell }
      />
      <BodyCellPure
        name="listId"
        className={ alignStyles.alignRight }
        rowIndex={ props.rowIndex }
        rowData={ row }
        cellCallback={
          (cellProps) => getListIdCell(cellProps, onSearch)
        }
      />
      <BodyCellPure
        name="identifier"
        className={
          cn(styles.identifierCell, alignStyles.alignRight, spacesStyles.ptn, spacesStyles.pbn, spacesStyles.prl)
        }
        rowIndex={ props.rowIndex }
        rowData={ row }
        cellCallback={ getIdentifierCell }
      />
      <BodyCellPure
        name="dueBy"
        className={ cn(styles.dueByCell, alignStyles.alignRight) }
        rowIndex={ props.rowIndex }
        rowData={ row }
        cellCallback={ getDueByCell }
      />
    </tr>
  );
};

export default withRouter(BwicRow);
